/**
 * @file 质押结果弹窗
 */
import { Modal, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useParams } from '@web3/base-hooks';
import { useOrderStatus } from '@/hooks/order';
import { GasStore, RewardQuery, ClaimType } from '@/types/claim';
import { PendingArr, SuccessArr, FailArr } from '@/config';
import { useRefreshContext } from '@/hooks/useRefresh';
import {
  OrderResultPending,
  OrderResultSuccess,
  OrderResultFail,
  Row,
} from '@/components';
import { MultiIconSpecial } from '@/components/multiIcon';
import { ClaimContent } from '../claimContent';
import cls from 'classnames';
import { formatUSDYield } from '@/utils/num';
import { useCurrentChainAddress } from '@/hooks/wallet';
import { PoolInfo } from '@/types/pool';
import { appPath } from '@web3/base-utils';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  gasStore: GasStore;
  rewardList: RewardQuery[];
  rewardValue: number;
  orderCode: string;
  claimType: ClaimType;
  poolInfo: PoolInfo;
}

export const OrderResultModal = (props: Props) => {
  const { show, gasStore, orderCode, rewardList, rewardValue, poolInfo } =
    props;
  const fm = useFm();
  const { locale } = useParams();
  const { refresh } = useRefreshContext();
  const { walletAddress } = useCurrentChainAddress(poolInfo.chainCode);

  const onConfirm = () => {
    if (window.top) {
      window.top.location.href = `/${locale}${appPath}/history?chainId=${poolInfo.chainId}&poolId=${poolInfo.id}`;
    }
  };

  const { orderStatusData } = useOrderStatus(orderCode);

  return (
    <Modal
      open={show}
      onOk={onConfirm}
      onCancel={refresh}
      width={480}
      footer={null}
      modal={false}
      title={fm('claim_revenue')}
    >
      {PendingArr.includes(orderStatusData.status) && (
        <OrderResultPending finishTime={orderStatusData.finishTime}>
          <div className={styles.pendingContent}>
            <ClaimContent rewardList={rewardList} rewardValue={rewardValue} />
          </div>
          <Row
            label={fm('estimated_cost')}
            className={styles.mt12}
            value={`${gasStore.amount} ${gasStore.symbol} (${formatUSDYield(gasStore.price)})`}
          />
        </OrderResultPending>
      )}
      {SuccessArr.includes(orderStatusData.status) && (
        <OrderResultSuccess
          data={[
            {
              label: fm('fromContractAddress'),
              address: poolInfo.contractAddress,
            },
            {
              label: fm('toWalletAddress'),
              address: walletAddress,
            },
            {
              label: fm('transactionHistory'),
              address: orderStatusData.hash,
            },
          ]}
        >
          <>
            <div className={cls(styles.successDesc, styles.row)}>
              <div className={styles.successDescText}>
                {fm('reward_success')}
              </div>
              <MultiIconSpecial
                data={rewardList.map((item) => {
                  return {
                    url: item.iconUrl,
                    amount: item.amount,
                    symbol: item.symbol,
                  };
                })}
              />
            </div>
            <div
              className={cls(styles.successDesc, styles.row)}
            >{`${fm('chainExecutionDelayNotice')}`}</div>
          </>
        </OrderResultSuccess>
      )}
      {FailArr.includes(orderStatusData.status) && (
        <OrderResultFail errorText={fm('operationNetworkIssueRetry')} />
      )}

      <Button className={styles.button} variant="primary" onClick={onConfirm}>
        {fm('ido_view_explorer')}
      </Button>
    </Modal>
  );
};
